import React from 'react';

import { Container } from 'components/container/Container';
import { Row } from 'components/row/Row';

import s from './ImageBlock.scss';

interface IProps {
  children: React.ReactElement;
}

export const ImageBlock = ({children}: IProps) => {

  if (!children) {
    return null;
  }

  return (
    <Container>
      <Row>
        <div className={s.imageBlock}>
          {children}
        </div>
      </Row>
    </Container>
  );
};
